'use client';

import { useEffect, useState } from 'react';
import useVelocityStore from '../stores/VelocityStore/useVelocityStore';
import WalletConnectionState from '../utils/WalletConnectionState';

type WalletStateData = {
	instance: WalletConnectionState;
};

/**
 * This hook wraps the current wallet state in the store to make it easily accessible and useful
 * @returns
 */
const useCurrentWalletConnectionState = (): WalletStateData => {
	const walletConnectionState = useVelocityStore(
		(s) => s.wallet.connectionState
	);
	const walletConnectionStateVal = useVelocityStore(
		(s) => s.wallet.connectionState.state
	);

	const currentAuthorityConnectionState = walletConnectionState;

	const updateStateData = () => ({
		instance: currentAuthorityConnectionState,
	});

	const [stateData, setStateData] = useState(updateStateData());

	useEffect(() => {
		const newStateData = updateStateData();
		setStateData(newStateData);
	}, [walletConnectionStateVal, currentAuthorityConnectionState.state]);

	return stateData;
};

export default useCurrentWalletConnectionState;
